import React, { useEffect, useState } from 'react'
import { useMyContext } from '../../../components/Provider/CommonProvider'
import { Link, useLocation } from 'react-router-dom'
import AdminDeleteModal from '../../../components/CommonComponents/AdminDeleteModal'
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { toast } from 'react-toastify'
import Response_Processing from '../../../layout/Others/Response_Processing'
import { BiRecycle } from 'react-icons/bi'
import { RxReload } from 'react-icons/rx'
import { donwloadCSV, downloadPDF, downloadXLSX, findUploadName } from '../../../components/CommonMethod/CommonMethods'
import NoRecordTable from '../../../components/CommonComponents/NoRecordTable'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaEllipsisVertical } from 'react-icons/fa6'
import MessageBox from '../../../components/CommonComponents/MessageBox'
import { IconDeleteFigma, IconDeleteSolid, IconEditFigma, IconSolidEdit } from '../../../Assets/MyIcons'
import { LiaUndoAltSolid } from 'react-icons/lia'
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton'
import AdminProcessButton from '../../../components/CommonComponents/AdminProcessButton'
import AdminVideoStatus from '../../../components/CommonComponents/AdminVideoStatus'
import { connect } from 'react-redux'
import EpisodeSiteStorage from './EpisodeSiteStorage'
import { getItemToken } from "../../../Utils/localStorageUtils";
import AdminBackNavigation from '../../../components/CommonComponents/AdminBackNavigation'
import AdminTooltip from '../../../components/CommonComponents/AdminTooltip';
import axios from 'axios';
import { CiShare1 } from "react-icons/ci";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import StorageLimitModal from '../../../components/CommonComponents/StorageLimitModal';

const ManageSeason = ({ storageSetting, siteTheme }) => {
    const location = useLocation()
    const { search } = useLocation();
    const headers = getItemToken('access_token')
    const queryParams = new URLSearchParams(search);
    const seriesId = queryParams.get('seriesid');
    const seasonId = queryParams.get('seasonid');
    const episodeId = queryParams.get('episodeid');
    const baseURL = process.env.REACT_APP_Baseurl
    const episodeApi = `${baseURL}/admin/series/season/${seriesId}/${seasonId}`
    const multiDelete = `${baseURL}/admin/series/episode/multi-delete`
    const listApi = `${baseURL}/admin`
    const orderApi = `${baseURL}/admin/series/episode/order`

    const languageApi = `${baseURL}/admin/User-Translate-Language`

    const { fetchRequest, fileResponse, clearFileResponse } = useMyContext()

    const [showStorageModal, setShowStorageModal] = useState(false);
    useEffect(() => {
        if (fileResponse === 413) {
            setShowStorageModal(true);
        }
    }, [fileResponse]);

    const handleStorageModalClose = () => {
        setShowStorageModal(false);
        clearFileResponse();
    };

    // Transcoding status banner state
    const [transcodingEnabled, setTranscodingEnabled] = useState(true);
    const [hideTranscodingBanner, setHideTranscodingBanner] = useState(false);

    const [episodeData, setEpisodeData] = useState({ data: "", response_loading: true, response_error: "", response_status: false })

    const [languageCode, setLanguageCode] = useState('');
    console.log("episodeData?.data?.episodes?.slug", episodeData?.data?.episodes?.[0]?.slug)

    // Fetch transcoding status (from setup-progress API)
    useEffect(() => {
        let cancelled = false;
        const fetchTranscodingStatus = async () => {
            try {
                const resp = await axios.get(`${baseURL}/admin/setup-progress`, { headers });
                const enabled = !!resp?.data?.data?.progress?.transcoding;
                if (!cancelled) setTranscodingEnabled(enabled);
            } catch (e) {
                // silent failure
            }
        };
        fetchTranscodingStatus();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [baseURL]);

    useEffect(() => {
        const fetchLanguageCode = async () => {
            try {
                const { data } = await axios.get(languageApi, { headers });
                if (data?.status) {
                    const language = data?.Language_Code || 'en'; // fallback to 'en' or another default if needed
                    setLanguageCode(language);
                } else {
                    console.warn('Unexpected API response format:', data);
                }
            } catch (error) {
                const errorMsg = error?.response?.data?.message || error.message || 'Unknown error';
                console.error('Error fetching language code:', errorMsg);
            }
        };
        fetchLanguageCode();
    }, []);


    const baseUrl = process.env.REACT_APP_Baseurl_Frontend?.replace(/\/$/, '');

    const shouldTranslate = siteTheme?.translate_checkout === 1;
    const videoPath = shouldTranslate
        ? `${baseUrl}/${languageCode}/series/${episodeData?.slug}`
        : `${baseUrl}/series/${episodeData?.data?.series?.slug}/${episodeData?.data?.episodes?.[0]?.slug}/${episodeData?.data?.episodes?.[0]?.id}`;


    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [modelClose, setModelClose] = useState(false);
    const [selectAllData, setSelectAllData] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [itemToDelete, setItemToDelete] = useState([]);
    const [deleteActionType, setDeleteActionType] = useState(2);
    const [draft, setDraft] = useState(0);
    const [formData, setFormData] = useState({
        state: "formData",
        view_type: "list",
        view_type_option: [{
            name: "List",
            value: "list"
        },
        {
            name: "Gallery",
            value: "grid"
        }]
    })
    const handleSingleDelete = (id) => {
        setItemToDelete([id]);
        setModelClose(true);
        setSelectAllData(false);
        if (draft === 1) {
            setDeleteActionType(3)
        }
    };

    const handleSelectAllData = () => {
        setSelectAllData(!selectAllData);
        setItemToDelete(selectAllData ? [] : episodeData?.data?.episodes?.map((item) => item?.id));
    };


    const saveShuffleOrder = async (updatedItems) => {
        setShowOverlay(true);

        if (!updatedItems || updatedItems?.length === 0) {
            toast.error("Menu items are empty");
            return;
        }
        else {
            const ids = updatedItems?.map((menuItem) => menuItem?.id);
            const positions = updatedItems?.map((_, index) => index + 1);
            const requestData = {
                id: ids,
                position: positions,
                season_id: seasonId,
            };
            try {
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${orderApi}`,
                    params: {},
                    data: { ...requestData },
                })
                const result = response;
                if (result?.status) {
                    toast.success(result?.message)
                    setWithOutRefresh(!withOutRefresh)
                    setShowOverlay(false);
                }
                else {
                    setShowOverlay(false)
                    toast.error(result?.message)
                }
            } catch (err) {
                setShowOverlay(false)
                console.error(err);
                var errorMessage = err?.response?.data?.message;
                toast.error(errorMessage)
            }
        }
    };


    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const episodes = episodeData?.data?.episodes;
        if (!Array.isArray(episodes)) {
            console.error("Episodes array not found!", episodes);
            return;
        }
        const reorderedItems = Array.from(episodes);
        const [movedItem] = reorderedItems?.splice(result.source.index, 1);
        reorderedItems?.splice(result.destination.index, 0, movedItem);
        setEpisodeData((prev) => ({
            ...prev,
            data: {
                ...prev.data,
                episodes: reorderedItems
            }
        }));
        saveShuffleOrder(reorderedItems);
    };


    const fetchAllData = async (type, find) => {
        const data = await fetchRequest({
            method: 'GET',
            url: `${episodeApi}`,
            params: { search: find == "ALL" ? null : formData?.title, soft_delete: draft },
            data: {},
        })
        const updatedList = data?.episodes?.map((item) => {
            const UploadStatus = findUploadName(item?.uploaded_by);
            return {
                ...item, uploaded_by: UploadStatus,
            };
        });
        if (type == "CSV") {
            await donwloadCSV(updatedList, "EPISODE-LIST")
        }
        if (type == "PDF") {
            await downloadPDF(updatedList, "EPISODE-LIST", ["INDEX", "ID", "TITLE", "UPLOADED_BY", "SERIES_ID", "SEASON_ID"])
        }
        if (type == "XLSX") {
            await downloadXLSX(updatedList, "EPISODE-LIST", ["INDEX", "ID", "TITLE", "UPLOADED_BY", "SERIES_ID", "SEASON_ID"])
        }
    };
    const handleInput = (e) => {
        const { type, name, value, checked } = e.target
        if (type === "search") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }))
        }
        if (type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    }
    const handleSingleFile = (itemId) => {
        if (itemToDelete?.includes(itemId)) {
            setItemToDelete(
                itemToDelete?.filter((id) => id !== itemId)
            );
        } else {
            setItemToDelete([...itemToDelete, itemId]);
        }
    };

    const closeModal = () => {
        setModelClose(!closeModal);
        setItemToDelete([])
        setDeleteActionType(2)
        setSelectAllData(false)
    };


    const handleConfirmDelete = async (actionType) => {
        setShowOverlay(true);
        console.log(itemToDelete, "itemToDelete")
        await fetchRequest({
            method: 'DELETE',
            url: `${multiDelete}`,
            params: {},
            data: { id: [...itemToDelete], action: actionType || deleteActionType },
        })
            .then(response => {
                const result = response;
                if (result?.status) {
                    toast.success(result?.message);
                    setItemToDelete([])
                }
            })
            .catch(error => {
                toast.error(error?.response?.data?.message || error?.message)
            }).finally(() => {
                setShowOverlay(false)
                setWithOutRefresh(!withOutRefresh);
                closeModal();
            })
    };

    const reCycleBin = () => {
        setDraft(prev => prev === 1 ? 0 : 1);
        setItemToDelete([]);
        setSelectAllData(false);
    };

    const reloadAction = () => {
        setDraft(0)
        setWithOutRefresh(prev => !prev)
    }
    const singlePeramanentDelete = (id) => {
        setModelClose(true);
        setItemToDelete([id]);
        setDeleteActionType(1)
    }


    const fetchData = async () => {
        setEpisodeData({ data: "", response_loading: true, response_error: "", response_status: false });
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${episodeApi}`,
                params: { soft_delete: draft, search: formData?.title },
                data: {}
            })
            setEpisodeData({
                data: {
                    ...response,
                    episodes: response.episodes?.sort((a, b) => parseInt(a.episode_order) - parseInt(b.episode_order))
                },
                response_loading: false, response_error: "", response_status: true
            });

        } catch (error) {
            setEpisodeData({ data: "", response_loading: false, response_error: error?.response?.data?.message || error?.message, response_status: false })
        }
    };
    useEffect(() => {
        if (draft === 0) {
            setDeleteActionType(2)
        }
        if (draft === 1) {
            setDeleteActionType(3)
        }
        if (draft === 1) {
            setDeleteActionType(1)
        }
    }, [draft])
    useEffect(() => {
        fetchData()
    }, [withOutRefresh, draft, formData?.title, location])
    return (
        <div>
            {storageSetting?.site_storage === 1 && <StorageLimitModal open={showStorageModal} onClose={handleStorageModalClose} />}

            {(!transcodingEnabled && !hideTranscodingBanner) && (
                <div className="alert alert-warning d-flex align-items-center justify-content-between mt-2">
                    <div className="d-flex align-items-center">
                        <IoIosInformationCircleOutline size={20} className="me-2" />
                        <div>
                            <div className="fw-semibold">Enable Transcoding for seamless uploads</div>
                            <small className="text-muted">Turn on transcoding to ensure smooth processing and playback of uploaded videos.</small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <Link
                            to="/site/transcoding-setting"
                            className="link-primary fw-semibold text-decoration-underline"
                        >
                            Go to Transcoding Settings
                        </Link>


                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setHideTranscodingBanner(true)} aria-label="Dismiss">
                            <IoClose />
                        </button>
                    </div>
                </div>
            )}
            <AdminBackNavigation path={`/edit-series/${seriesId}`} text='Back' />
            <EpisodeSiteStorage />
            {showOverlay && <Response_Processing />}
            {modelClose && <AdminDeleteModal messageClassName={deleteActionType === 1 ? "warningColor" : ""} headingText={deleteActionType == 3 ? "Confirm Undo" : deleteActionType == 1 ? "Confirm Permanent Delete" : "Confirm Delete"} message={deleteActionType == 2 ? "Are you sure you want to delete" : deleteActionType == 3 ? "Are you sure you want to Undo item" : deleteActionType == 1 ? "Warning: This action will permanently delete the selected items from the server. Once deleted, the data cannot be recovered. Are you sure you want to proceed?" : "Are you sure you want to Delete"} modelClose={modelClose} deleteClose={closeModal} deleteAction={() => handleConfirmDelete()} buttonText={"custom"} actionText={deleteActionType == 1 ? "Delete Permanent" : deleteActionType == 2 ? "Delete" : deleteActionType == 3 ? "Undo" : ""} type={"default"} />}
            {!episodeId ? <div className='theme-bg-color p-3 rounded-3 mb-5'>
                <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
                    <input type='search' placeholder='Search' name="title" className='rounded-3  theme-border-color border-solid-width border-solid table-search  theme-bg-color-secondary' onChange={handleInput} id='searchInput' />
                    <div className=' d-flex align-items-center'>
                        {(draft !== 1 && itemToDelete?.length > 0) ? <AdminCustomButton id="episode-delete-button" saveText="Delete" className="warningColorBg p-2 rounded-2 d-inline-flex align-items-center me-3 " saveMethod={() => { setModelClose(true); setDeleteActionType(2) }} /> : ""}
                        {(draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton id="episode-undo-button" saveText="Undo" className={"mx-3"} saveMethod={() => { setModelClose(true); setDeleteActionType(3) }} /> : ""}
                        {(draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton id="episode-permanent-delete-button" saveText="Delete Permanent" className="warningColorBg p-2 rounded-2 d-inline-flex align-items-center me-3 " saveMethod={() => { setModelClose(true); setDeleteActionType(1) }} /> : ""}
                        <button className={` reloadButton p-2 me-2  custom-tool-tip-parent border border-2 rounded-circle theme-border-color ${draft ? "button-bg-color theme-button-text-color" : " bg-transparent theme-text-color"}`} onClick={reCycleBin} id='recycleButton'>
                            <BiRecycle style={{ width: "18px", height: "15px" }} />
                            <AdminTooltip text="Recycle Bin" top={"-41px"} className="d-none custom-tool-tip" />

                        </button>
                        <button className={`bg-transparent reloadButton custom-tool-tip-parent theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color `} onClick={reloadAction} id='reloadButton'>
                            <RxReload style={{ width: "18px", height: "15px" }} className={`${episodeData?.response_loading ? "rotate-load" : ""}`} />
                            <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
                        </button>
                        <div className="dropdown d-block ms-2 " key={"2"}>
                            <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                                <span className="fw-bolder text-white">Export</span>
                                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                            </button>
                            <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportButton" >
                                <li className="dropdown-item theme-text-color" id='exportCSV' onClick={() => fetchAllData("CSV")}>CSV</li>
                                <li className="dropdown-item theme-text-color" id='exportPDF' onClick={() => fetchAllData("PDF")}>PDF</li>
                                <li className="dropdown-item theme-text-color" id='exportXLSX' onClick={() => fetchAllData("XLSX")}>XLSX </li>
                            </ul>
                        </div>
                        <div className="dropdown d-block ms-2 " key={"2"}>
                            <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                                <span className="fw-bolder text-white">Export all</span>
                                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                            </button>
                            <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                                <li className="dropdown-item theme-text-color" id='exportAllCSV' onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                                <li className="dropdown-item theme-text-color" id='exportAllPDF' onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                                <li className="dropdown-item theme-text-color" id='exportAllXLSX' onClick={() => fetchAllData("XLSX", "ALL")}>XLSX </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="bootstrapTable theme-bg-color p-3 rounded-2">
                    <div className="">
                        <div className="row m-0 theme-border-bottom-secondary pb-3">
                            <div className="col-lg-1 rowCheckboxDrag"> <label><input type="checkbox" id="episode-select-all" checked={selectAllData} onChange={handleSelectAllData} /> </label></div>
                            <div className="col-lg-3"> <label className="theme-text-color fw-bold fs-6"> Episode  </label> </div>
                            <div className="col-lg-2 "><label className="theme-text-color fw-bold fs-6">Uploaded by</label></div>
                            <div className="col-lg-2"><label className="theme-text-color fw-bold fs-6">Transcoding Status</label></div>
                            <div className="col-lg-2 "><label className="theme-text-color fw-bold fs-6">Status</label></div>
                            <div className="col-lg-2"> <label className="theme-text-color fw-bold fs-6">Actions</label></div>
                        </div>
                    </div>
                </div>

                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="menu-items" className="theme-bg-color"   >
                        {(provided) => (
                            <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color m-0 p-0 list-unstyled">
                                {episodeData?.response_loading ? <NoRecordTable result={episodeData?.data?.episodes?.length} loader={true} /> :
                                    episodeData?.data?.episodes?.length ? episodeData?.data?.episodes?.map((item, index) => (
                                        <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                                            {(provided) => (
                                                <li id="episode-drag" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={` theme-bg-color theme-text-color   ${item.episode_order} index ${index + 1} w-100 theme-border-bottom-secondary px-3`} >
                                                    <div className="row m-0 p-0 align-items-center">
                                                        <div className="rowCheckboxDrag col-lg-1 category-order-title">
                                                            <input
                                                                type="checkbox"
                                                                id="episode-select-item"
                                                                checked={itemToDelete?.includes(item.id)}
                                                                onChange={() => handleSingleFile(item.id)}
                                                            />
                                                        </div>

                                                        <div className="col-lg-3 category-order-title">
                                                            <div className="d-flex justify-content-between align-items-center ">
                                                                <img src={item?.Thumbnail} className="profile" alt="image_all" />
                                                                <div className="rightVideoTitle ms-3" id="episode-preview-link">
                                                                    {/* <span id="episode-preview-link" className="theme-text-color table-heading d-flex  align-items-center" target="_blank" > <span title={`${item.slug}`}>{`${item?.title?.slice(0, 15)}...`} </span> </span> */}
                                                                    <Link className="theme-text-color table-heading d-flex align-items-center" target="_blank" to={videoPath}><span title={`${item.slug}`}>{`${item?.title?.slice(0, 15)}...`}</span>
                                                                        <CiShare1 style={{ width: "15px", height: "15px", strokeWidth: '1px', marginLeft: "6px" }} />
                                                                    </Link>
                                                                    <span className="dateText table-subheading "> {item?.upload_on}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2  category-order-title">
                                                            <div className=" theme-text-color">{findUploadName(item?.uploaded_by)} </div>
                                                        </div>
                                                        <div className="col-lg-2 category-order-title">
                                                            <AdminProcessButton cell={item?.current_status} row={item} />

                                                        </div>
                                                        <div className="col-lg-2 category-order-title">
                                                            <AdminVideoStatus cell={item?.video_status} row={item} />
                                                        </div>
                                                        <div className="col-lg-2 category-order-title">
                                                            <div className="editdropdown" id="episode-action">
                                                                <span className="editdropdown-button">
                                                                    <FaEllipsisVertical className="theme-text-color" />
                                                                </span>
                                                                <div className="editdropdown-menu theme-bg-color">
                                                                    {draft !== 1 &&
                                                                        <>
                                                                            <Link id="episode-edit-link" to={`/edit-episode?episodeid=${item?.id}`} className="theme-text-color theme-bg-color">
                                                                                <IconEditFigma styled={{ width: "20px", height: "20px" }} /> <MessageBox text="Edit Meta" classname='ms-2 theme-text-color' />
                                                                            </Link>
                                                                            <Link id="epsiode-edit-video-link" to={`/manage-episode?seriesid=${seriesId}&seasonid=${seasonId}&episodeid=${item?.id}`} className="theme-text-color theme-bg-color">
                                                                                <IconEditFigma styled={{ width: "20px", height: "20px" }} /> <MessageBox text="Edit Video" classname='ms-2 theme-text-color' />
                                                                            </Link>
                                                                        </>}
                                                                    <div id="episode-delete-button" onClick={() => handleSingleDelete(item?.id)} className="commonActionPadding theme-bg-color">
                                                                        {draft == 1 ? <LiaUndoAltSolid style={{ width: "20px", height: "20px" }} /> : <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />}
                                                                        <MessageBox text={`${draft == 1 ? "undo" : "Delete"}`} classname='ms-2 theme-text-color' />
                                                                    </div>
                                                                    {draft == 1 && (<div id={`permanentDeleteButton`} onClick={() => singlePeramanentDelete(item?.id)} className="commonActionPadding theme-bg-color">
                                                                        <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                                                                        <MessageBox text="Delete Permanent" classname='ms-2 theme-text-color'></MessageBox>
                                                                    </div>)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            )}
                                        </Draggable>
                                    )) : <NoRecordTable result={episodeData?.data?.episodes?.length} loader={false} />}
                                {provided.placeholder}
                            </ul>
                        )}
                    </Droppable>
                </DragDropContext>


            </div > : ""}

        </div>
    )
}
const mapStateToProps = (state) => ({
    storageSetting: state.storageSetting.data,
    storageSettingError: state.storageSetting.error,
    storageLoading: state.storageSetting.loading,
    siteTheme: state.siteTheme.siteTheme
});
export default connect(mapStateToProps)(ManageSeason)